import reducer from './reducers';
import * as eventsActions from './actions';
import * as eventsSelectors from './selectors';

export { eventsActions, eventsSelectors };
export default reducer;